export const urls = {
  waterfallMainUrl: 'https://waterfall.foundation/',
};
